export default __webpack_public_path__ + "assets/courier-overview-video-2-thumbnail-new.png";